export enum SortOrderEnum {
  Ascending = "ASC",
  Descending = "DESC",
}
